module.exports = __webpack_public_path__ + "img/background-main.b0e64533.svg";